import SearchConstValues from '@/ecm/variables/SearchConstValues';
import ConditionItem from '@/ecm/models/search/ConditionItem';
import store from '@/store';
import Utils from '../../../ecm/common/Utils';
import FieldType from '@/ecm/variables/FieldType';
import { VAR_PREFIX } from '../../../ecm/common/Constants';
import VariableService from '@/services/VariableService';

export default {
    GetDisplayValueFromFieldValue(condition, context) {
        switch (condition) {
            case SearchConstValues.Today:
                return context.$t('Today');
            case SearchConstValues.MySelf:
                return context.$t('Myself');
            case SearchConstValues.MySelf_Id:
                return context.$t('MyselfId');
            case SearchConstValues.Empty || SearchConstValues.NotEmpty:
                return '';
            default:
                return condition
                    .replace(
                        SearchConstValues.DaysBeforeToday,
                        `${context.$t('DaysBeforeToday')} ${context.$t('Today')}`
                    )
                    .replace(
                        SearchConstValues.DaysAfterToday,
                        `${context.$t('DaysAfterToday')} ${context.$t('Today')}`
                    );
        }
    },
    async GetDisplayConditionStr(conditionStr, fieldCodesDictionary, context) {
        if (!conditionStr) return;

        const conditionItems = [];
        let displayConditionStr = '';

        for (const condition of conditionStr.split(';')) {
            const conditionItem = new ConditionItem(condition);
            await this.setConditionItemDisplayValues(conditionItem, fieldCodesDictionary, context);
            conditionItems.push(conditionItem);
        }
        if (conditionItems.length > 0) {
            displayConditionStr = conditionItems
                .map((item) => item.displayText())
                .join(';');
        }
        return displayConditionStr;
    },
    async setConditionItemDisplayValues(conditionItem, fieldCodesDictionary, context) {
        const standardFields = Object.fromEntries(store.getters['account/searchStandardFields'].map(x => [x.Code, x.Title]));
        const fieldsDictionary = { ...standardFields, ...fieldCodesDictionary };
        conditionItem.fieldTitle = fieldsDictionary[conditionItem.fieldCode];

        const searchConstValues = Object.values(SearchConstValues);

        const searchOperator = store.getters['account/searchOperators'].find(
            (x) => x.Code == conditionItem.searchOperatorCode
        );
        if (searchOperator) conditionItem.searchOperatorTitle = searchOperator.Title;

        if (searchConstValues.some(value => conditionItem.fieldValue.includes(value))) {
            conditionItem.fieldDisplayValue = this.GetDisplayValueFromFieldValue(conditionItem.fieldValue, context);
            return;
        }

        if (!conditionItem.fieldValue.startsWith(VAR_PREFIX)) {
            switch (conditionItem.fieldType) {
                case FieldType.DateTime:
                    conditionItem.fieldDisplayValue = Utils.date.toUserFormatFromSearchPatterDate(
                        conditionItem.fieldValue
                    );
                    break;
                case FieldType.Numeric:
                    conditionItem.fieldDisplayValue = Utils.number.toUserFormatFromSearchPatternNumber(
                        conditionItem.fieldValue
                    );
                    break;
                case FieldType.String:
                case FieldType.StaticList:
                case FieldType.DynamicList:
                    conditionItem.fieldDisplayValue = conditionItem.fieldValue;
                    break;
            }
        } else {
            const result = await VariableService.getValues([conditionItem.fieldValue]);
            const variableValues = result.reduce((acc, cur) => {
                acc[cur.code] = cur;
                return acc;
            }, {});
            conditionItem.fieldDisplayValue = this.getVariableValueToShow(variableValues[conditionItem.fieldValue]);
        }
    },
    getVariableValueToShow(variable) {
        let variableValue = variable.value;
        if (variable.type === FieldType.DateTime) {
            variableValue = Utils.date.toUserFormatFromIso(variable.value, false);
        } else if (variable.type === FieldType.Numeric) {
            const userDecSep = store.getters['account/user'].MetricDecimalSep;
            const userThouSep = store.getters['account/user'].MetricThousandSep;
            variableValue = Utils.number.toUserFormat(variable.value, userDecSep, userThouSep);
        }
        return variable.name + ': ' + variableValue;
    },
    SetUserFormatValueIntoConditionStr(conditionStr) {
        if (!conditionStr) return;

        const conditionItems = [];
        const searchConstValues = Object.values(SearchConstValues);

        conditionStr.split(';').forEach((condition) => {
            const conditionItem = new ConditionItem(condition);

            if (searchConstValues.some(value => conditionItem.fieldValue.includes(value))) {
                conditionItems.push(conditionItem);
                return;
            }

            if (!conditionItem.fieldValue.startsWith(VAR_PREFIX)) {
                switch (conditionItem.fieldType) {
                    case FieldType.DateTime:
                        conditionItem.fieldValue = Utils.date.toUserFormatFromSearchPatterDate(conditionItem.fieldValue);
                        break;
                    case FieldType.Numeric:
                        conditionItem.fieldValue = Utils.number.toUserFormatFromSearchPatternNumber(conditionItem.fieldValue);
                        break;
                }
            }

            conditionItems.push(conditionItem);
        });

        let parsedConditionStr = '';
        if (conditionItems.length > 0) {
            parsedConditionStr = conditionItems
                .map((item) => item.conditionStr())
                .join(';');
        }
        return parsedConditionStr;
    }
};
